import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { OcorrenciaTipo } from '../../models/ocorrencia-tipo';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { OcorrenciaTipoService } from 'src/app/services/ocorrencia-tipo.service';
import swal from 'sweetalert2';
import { CadastrarOcorrenciaTipoModalComponent } from '../ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal/cadastrar-ocorrencia-tipo-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-ocorrencia-tipo-modal',
  templateUrl: './ocorrencia-tipo-modal.component.html',
  styleUrls: ['./ocorrencia-tipo-modal.component.scss']
})
export class OcorrenciaTipoModalComponent implements OnInit {
  descricao: string;
  ocorrenciaTipos: OcorrenciaTipo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<OcorrenciaTipoModalComponent>, 
    private carregandoService: CarregandoService, 
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, 
    private ocorrenciaTipoService: OcorrenciaTipoService, 
    private paginatorService: PaginatorService,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog
    ) {
  }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarOcorrenciaTipo();
  }

  buscarOcorrenciaTipo() {
    this.carregandoService.mostra('buscarOcorrenciaTipo');

    this.ocorrenciaTipoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc'), this.descricao).subscribe((data: any) => {
      this.ocorrenciaTipos = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarOcorrenciaTipo');
    }, (erro) => {
      this.carregandoService.esconde('buscarOcorrenciaTipo');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarOcorrenciaTipo();
  }

  fechar() {
    this.dialogRef.close();
  }

  excluirItem(idOcorrenciaTipo) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o tipo de ocorrência?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.ocorrenciaTipoService.excluir(idOcorrenciaTipo).subscribe(resp => {
          this.notificacaoService.sucesso('Tipo de ocorrência excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarOcorrenciaTipo();
        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarOcorrenciaTipoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: OcorrenciaTipo) => {
      if (result) {
        this.buscarOcorrenciaTipo();
      }
    });
  }

  editarItem(idOcorrenciaTipo: number) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarOcorrenciaTipoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idOcorrenciaTipo },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: OcorrenciaTipo) => {
      if (result) {
        this.buscarOcorrenciaTipo();
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}